import { Stack, Text } from 'ui';

import { EmptyCell } from '../../../packages/Table/components/EmptyCell/EmptyCell';

const FacultyAccessColumn = ({
  user,
}: {
  user?: { first_name: string | null; last_name: string | null; email: string | null };
}) => {
  if (!user?.first_name && !user?.last_name) {
    return <EmptyCell />;
  }

  return (
    <Stack gap={0}>
      {[user?.last_name, user?.first_name].filter(Boolean).join(', ')}

      {user?.email && (
        <Text fz="xxxs" c="gray" style={{ textWrap: 'nowrap' }}>
          {user?.email}
        </Text>
      )}
    </Stack>
  );
};

export { FacultyAccessColumn };
